//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productPics', {
//        templateUrl: 'views/components/views/productPics/productPics.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'productPicsService', function ($stateParams, stateService, productPicsService) {
//            const vm = this;
//            let prodId = $stateParams.prod_id;
            
//            vm.model = {
//                itemsListProductPictures: []
//            };

//            async function loadProductPictures() {
//                vm.model.itemsListProductPictures = await productPicsService.listProductPictures({ prod_id: prodId });
//            }
    		
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'productpic':
//                        go({
//                            productpicturebank_keyno: '0',
//                            prod_id: prodId
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = async function () {
//                loadProductPictures();
//            }
//        }]
//    });
//})();
